module.exports = __webpack_public_path__ + "static/media/Melissa3.b9724253.jpg";